// extracted by mini-css-extract-plugin
export default {"block":"styles_block__P7dfw","error-block":"styles_error-block__t5rL+","error-active":"styles_error-active__Pp1vF","label":"styles_label__QEE95","children":"styles_children__L8gIu"};